// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__27qeU","controls":"styles_controls__1aMuH","charLimit":"styles_charLimit__36ASa","input":"styles_input__1caLJ","send":"styles_send__1iMgQ"};